import { render } from "./returnList.vue?vue&type=template&id=c640d202&scoped=true"
import script from "./returnList.vue?vue&type=script&lang=js"
export * from "./returnList.vue?vue&type=script&lang=js"

import "./returnList.vue?vue&type=style&index=0&id=c640d202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c640d202"]])

export default __exports__